import MasterControllerContainer from './master-control.container';

export default MasterControllerContainer;
